export default __webpack_public_path__ + "static/network-2@2x-debfe0da9c14facc7dca4479ca8261e3.png";